import _Vue from 'vue';
import { vuetify } from '../vuetify';
import Dialog from './components/dialog.vue';
import { DialogPluginOptions, DialogType } from './types';

const dialog = {
  install(vue: typeof _Vue) {
    const Vue = vue;
    const callbacks: (() => void)[] = [];
    const dialog = new Vue({
      vuetify,
      methods: {
        open(params: DialogPluginOptions) {
          (this.$refs.dialog as DialogType).open_dialog(params);
        },
      },
      render: (h) => h(Dialog, {
        ref: 'dialog',
        on: {
          close() {
            (dialog.$refs.dialog as DialogType).close_dialog(() => {
              callbacks.forEach((fn) => {
                fn();
              });
            });
          },
        },
      }),
    }).$mount();
    const apis = {
      on_close(fn: () => void) {
        callbacks.push(fn);
      },
      open(params: DialogPluginOptions) {
        dialog.open(params);
        return this;
      },
    };

    Vue.prototype.$dialog = apis;
    Vue.dialog = apis;
  },
};

export { dialog };
